import { useMemo } from 'react';
import { ENVIRONMENT_CODES } from '../../constants';
import { environmentContext } from './environmentContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const EnvironmentProvider = ({
  children,
  tenant,
  environment = ENVIRONMENT_CODES.LIVE
}) => {
  const contextValues = useMemo(() => ({
    tenant,
    environment
  }), [tenant, environment]);
  return /*#__PURE__*/_jsx(environmentContext.Provider, {
    value: contextValues,
    children: children
  });
};
//# sourceMappingURL=EnvironmentProvider.js.map